<template>
    <a-card :bordered="false">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery" :model="queryParam" >
          <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.activity.activityname']"> 
              
             <a-input v-model="queryParam.activityname" :placeholder="this.language['cs.activity.activityname']"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.persongroup.pgroupcode']">
             <a-input v-model="queryParam.pgroupcode" :placeholder="this.language['cs.persongroup.pgroupcode']"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="this.language['cs.persongroup.pgroupname']">
             <a-input v-model="queryParam.pgroupname" :placeholder="this.language['cs.persongroup.pgroupname']"></a-input>
            </a-form-item>
          </a-col>
          
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{this.language['common.searchButton']}}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{this.language['common.resetButton']}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 查询区域-END -->
      
      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-button @click="handleAdd" type="primary" icon="plus" v-has="'persongroup:add'">新增</a-button>
        <!-- 高级查询区域 -->
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel" v-has="'persongroup:deletebatch'"><a-icon type="delete"/>删除</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
        </a-dropdown>
      </div>
  
      <!-- table区域-begin -->
      <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        </div>
  
        <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="syspgid"
          class="j-table-force-nowrap"
          :scroll="{x:1800}"
          :dataSource="dataSource"
          :pagination="ipagination"
          :columns="columns"
          :loading="loading"
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
          @change="handleTableChange">
          <template slot="htmlSlot" slot-scope="text">
            <div v-html="text"></div>
          </template>
          <template slot="isvalidSlot" slot-scope="text,record" >
            <a-switch  v-model="record.status" checkedChildren="ON"  unCheckedChildren="OFF"  @change="onSwitchChange(record,$event)" />
         
        </template>
          <span slot="action" slot-scope="text, record">
            <a @click="handleEdit(record)" v-has="'persongroup:edit'">{{language['common.edit']}}</a>
  
            <a-divider type="vertical" />
            <a-dropdown>
              <a class="ant-dropdown-link">{{language['common.more']}} <a-icon type="down" /></a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a @click="handleDetail(record)" v-has="'persongroup:view'">{{language['common.look']}}</a>
                </a-menu-item>
                <a-menu-item v-has="'persongroup:delete'">
                  <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.syspgid)">
                    <a>{{language['common.delete']}}</a>
                  </a-popconfirm>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </span>
        </a-table>
      </div>
 
      <person-group-modal ref="modalForm" @ok="modalFormOk"></person-group-modal>
      
    </a-card>
  </template>
  
  <script>
    import { httpAction, getAction } from '@/api/manageChooseSeat'
    import '@/assets/less/TableExpand.less'
    import { JeecgListMixin } from '@/views/chooseSeat/mixins/JeecgListMixin.js'
    import { getDictItemsFromCache  } from '@/api/api'
    import PersonGroupModal from './modules/PersonGroupModal'

    export default {
      name: "PersonGroupList",
      mixins:[JeecgListMixin],
      components: {
        PersonGroupModal
        
      },
      data () {
        return {
          description: '人員分組信息',
          // 表头
         
          url: {
            list: "/PersonGroup/list",
            delete: "/PersonGroup/delete",
            deleteBatch: "/PersonGroup/deleteBatch",
            switchChange: "/PersonGroup/switchChange",
            
          },
         
        }
      },
      created() {
      },
      mounted(){
      
      },
      computed: {
        language() {
          return this.$store.getters.language
        },
        columns() {
          if (this.language) {
            return  [
            {
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {
              title:this.language['cs.persongroup.pgroupcode'],
              align:"center",
              width:150,
              ellipsis: true,
              dataIndex: 'pgroupcode'
            },
            {
              title:this.language['cs.persongroup.pgroupname'],
              align:"center",
              width:150,
              ellipsis: true,
              dataIndex: 'pgroupname'
            },
            {
              title:this.language['cs.activeFlag'],
              align:"center",
              width:150,
              dataIndex: 'isvalid',
              scopedSlots: { customRender: 'isvalidSlot' }
            }, 
            {
              title:this.language['common.sort'],
              align:"center",
              width:150,
              dataIndex: 'sort'
            }, 
            {
              title:this.language['cs.activity.activityname'],
              align:"center",
              width:150,
              dataIndex: 'activityname'
            },  
            {
              title:this.language['common.creator'],
              align:"center",
              width:150,
              dataIndex: 'creator'
            },  
            {
              title:this.language['common.createTime'],
              align:"center",
              width:150,
              dataIndex: 'createdate'
            },  
            {
              title:this.language['common.modifier'],
              align:"center",
              width:150,
              dataIndex: 'modifier'
            },  
            {
              title:this.language['common.modifyTime'],
              align:"center",
              width:150,
              dataIndex: 'modifydate'
            },  
            {
              title: '操作',
              dataIndex: 'action',
              align:"center",
              fixed:"right",
              width:147,
              scopedSlots: { customRender: 'action' },
            }
          ]
          }
        }
      },
      methods: {
        initDictConfig(){
        },
        searchQuery() {
        
        this.loadData(1);
        },
        onSwitchChange(val,checked) {
        val.isvalid = checked ? "Y" : "N";
        httpAction(this.url.switchChange, {syspgid:val.syspgid,isvalid:val.isvalid},'post').then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.$emit('ok')
            this.loadData();
          } else {
            this.$message.warning(res.message)
          }
          
        })
      },
      }
    }
  </script>
  <style scoped>
    @import '~@assets/less/common.less';
  </style>